import { msg } from "components/schema/msg";
import { validationPatterns } from "constant/validationPatterns";
import * as Yup from "yup";

export const CategorySchema = Yup.object().shape({
  name: Yup.string()
    .matches(validationPatterns.name, msg("categoryNameLetters"))
    .min(2, msg("categoryNameMin"))
    .required(msg("categoryNameRequired")),
});
